import React from 'react';
import { Card, Collapse } from 'react-bootstrap';

import { render_marked_issue } from '../utils/HiddenText';
import { render_text_lines } from '../utils/Sentences';

function RecommendedFixes({
	analysis_results,
	show_fixes,
	set_show_fixes
}){

	// The ids of the fixes marked CRITICAL after their category tag, as the backend lists them.
	const get_critical_fix_ids = ()=>{
		return Array.isArray(analysis_results.critical_fix_ids) ? analysis_results.critical_fix_ids : [];
	};

	// CRITICAL in red, in the category tag's own font.
	const render_critical_label = (item, critical_fix_ids)=>{
		if(!critical_fix_ids.includes(item.id)){
			return null;
		}

		return (
			<div className="fixes-category-tag fixes-critical-label">CRITICAL</div>
		);
	};

	const render_recommended_fixes_section = ()=>{
		const data = analysis_results.recommended_fixes;
		if(!data){
			return;
		}

		const critical_fix_ids = get_critical_fix_ids();

		return(
			<Card className="analysis-results-card fixes-card">
				<h3 className="fixes-title" 
					onClick={()=>set_show_fixes(!show_fixes)} 
					style={{cursor:'pointer'}}>
					Recommended Fixes {show_fixes ? "▲" : "▼"}
				</h3>
				<p className="fixes-desc">
					Specific improvements that can strengthen AI-search performance and overall content quality.
				</p>

				<Collapse in={show_fixes}>
				<div className="fixes-list">
					{data.map((item, index)=>{
						const cat_class = "fixes-cat-" + item.category.replace(/\s+/g,"_").toLowerCase();

						return(
							<div key={index} className="fixes-item-box">

								<div className="fixes-tag-row">
									<div className={"fixes-category-tag " + cat_class}>
										{item.category.toUpperCase()}
									</div>
									{render_critical_label(item, critical_fix_ids)}
								</div>

								<div className="fixes-issue">
									{render_marked_issue(item.issue, analysis_results)}
								</div>

								<div className="fixes-fix">
									{render_text_lines(item.fix)}
								</div>

							</div>
						);
					})}
				</div>
				</Collapse>
			</Card>
		);
	}

	if(!analysis_results || !analysis_results.recommended_fixes){
		return null;
	}

	return render_recommended_fixes_section();
}

export default RecommendedFixes;
